import {
    GET_VALIDATION_XLSX_DOCUMENT_REQUEST,
    GET_VALIDATION_XLSX_DOCUMENT_SUCCESS,
    GET_VALIDATION_XLSX_DOCUMENT_FAILURE,
    GET_VALIDATION_XLSX_DOCUMENT,
    DEFAULT_IMPORT
} from '../../actions/import/get-validation-result-actions';

const initialState = {
    ImportResult: [],
    isLoading: false,
    error: null,
};

const ImportValidationResultReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_VALIDATION_XLSX_DOCUMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_VALIDATION_XLSX_DOCUMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ImportResult: action.payload.validation_result || [],
            };
        case GET_VALIDATION_XLSX_DOCUMENT:
            return {
                ...state,
                isLoading: false,
                ImportResult: action.payload.validation_result || [],
            }
        case GET_VALIDATION_XLSX_DOCUMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case DEFAULT_IMPORT:
            console.log("dispatching default")
            return  initialState
        default:
            return state;
    }
};

export default ImportValidationResultReducer;